<ng-container *ngIf="containsTpm">
	<div class="text-condensed-14" [dcrHTMLKey]="isSnapshot ? 'SNAPSHOT_DISCLOSURE_TPM' : 'SHORT_TPM_DISCLOSURE'"></div>
</ng-container>
